const appModel = {
    FORECASTS: {
        appTitle: "AI Stock Forecasts",
        assetFolder: "forecasts",
        deviceType: "iPhoneX",
        startColor: "#2937f0",
        endColor: "#9f1ae2",
        mastheadTitle: "Forecast stock score via AI",
        mastheadText: "An innovative application that leverages Artificial Intelligence in order to forecast variation in stock value.",
        testimonialMessage: "An intuitive solution to track companies forecasts wrapped up in a single app",
        featureTitle1: "Fortune 100 companies",
        featureMessage1: "You can easily select a fortunee 100 company you want to forecast the stock value outcome",
        featureIcon1: "bi bi-building",
        featureTitle2: "Customizable",
        featureMessage2: "Create and manage custom companies, foreign companies and cryptocurrencies",
        featureIcon2: "bi bi-gear-wide-connected",
        featureTitle3: "AI based",
        featureMessage3: "Machine learning algorithms will calculate a score based on business news",
        featureIcon3: "bi bi-cpu",
        featureTitle4: "Free to Use",
        featureMessage4: "The App is free to download and use without any add",
        featureIcon4: "bi-patch-check",
        subsectionTitle: "Take advantage of Artificial Intelligence",
        subsectionMessage1: "This app predicts Fortune 100 companies stock price evolution through sentiment analysis using Twitter and News-api as the sources for data analysis.",
        subsectionMessage2: "You can also add, manage and save your own companies as well as cryptocurrencies to get a calculated score based on business news",
        appStoreURL: "https://apps.apple.com/us/app/ai-stock-forecasts/id1527494965",
        githubURL: "https://github.com/alexismoulin/AI-Stock-Forecasts",
        privacyPolicyURL: "https://alexismoulin.github.io/AI-Stock-Forecasts/"
    },
    FILTERS: {
        appTitle: "Deep Filters",
        assetFolder: "filters",
        deviceType: "iPhoneX",
        startColor: "#dddd7f",
        endColor: "#73fcd6",
        mastheadTitle: "Turn your photos into Art",
        mastheadText: "A cool App using Neural Style Transfer to make your pictures look amazing and sharable in one click.",
        testimonialMessage: "Apply artistic styles to your photos and share them with everyone",
        featureTitle1: "Each artwork is unique",
        featureMessage1: "Create an amazing artwork from each photo with different filters",
        featureIcon1: "bi bi-file-earmark-image",
        featureTitle2: "Share everywhere",
        featureMessage2: "The App connects directly to Facebook, Instagram, Twitter, etc. in one click",
        featureIcon2: "bi bi-box-arrow-up",
        featureTitle3: "AI based",
        featureMessage3: "Use Neural Network technology for impressive results",
        featureIcon3: "bi bi-cpu",
        featureTitle4: "Free to Use",
        featureMessage4: "The App is free to download and use without any add",
        featureIcon4: "bi-patch-check",
        subsectionTitle: "Take advantage of AI based filters",
        subsectionMessage1: "Apply 15 original filters based on Neural Style transfer technology to your photos in one click",
        subSectionMessage2: "",
        appStoreURL: "https://apps.apple.com/us/app/deep-filters/id1585438108",
        githubURL: "https://github.com/alexismoulin/Deep-Filters",
        privacyPolicyURL: "https://alexismoulin.github.io/Deep-Filters/"
    },
    WORKOUTS: {
        appTitle: "iWorkout",
        assetFolder: "workouts",
        deviceType: "Watch",
        startColor: "#be71df",
        endColor: "#f6c552",
        mastheadTitle: "Track your workout records",
        mastheadText: "A free app providing 200 exercices for which you can track your progress and your records.",
        testimonialMessage: "The perfect way to motivate yourself to beat your workout records",
        featureTitle1: "200 unique exercises available",
        featureMessage1: "You can plan your workout with a wide variety of exercises",
        featureIcon1: "bi bi-trophy",
        featureTitle2: "Track your health information",
        featureMessage2: "You have access to your heart rate and calory consumsion in real time",
        featureIcon2: "bi bi-file-medical",
        featureTitle3: "iCloud based",
        featureMessage3: "For syncing your records among all your devices",
        featureIcon3: "bi bi-cloud-arrow-up",
        featureTitle4: "Free to Use",
        featureMessage4: "The App is free to download and use without any add",
        featureIcon4: "bi-patch-check",
        subsectionTitle: "Take advantage of the built-in Health Features",
        subsectionMessage1: "It integrates perfectly with the Health app during workouts to provide you real time information on Heart Rate and Calory burn.",
        subSectionMessage2: "",
        appStoreURL: "https://apps.apple.com/us/app/iworkout/id1594024083",
        githubURL: "https://github.com/alexismoulin/iWorkOut",
        privacyPolicyURL: "https://alexismoulin.github.io/iWorkOut/"
    }
}

export default appModel;